import { render } from "./MaintenanceRegulatory.vue?vue&type=template&id=251fc2d3&scoped=true"
import script from "./MaintenanceRegulatory.vue?vue&type=script&lang=js"
export * from "./MaintenanceRegulatory.vue?vue&type=script&lang=js"

import "./MaintenanceRegulatory.vue?vue&type=style&index=0&id=251fc2d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251fc2d3"]])

export default __exports__